import React, { useContext } from "react";
import EditModal from "../../profiles/EditModal";
import { MediaOutletContext } from "../data/media_outlet_context_management";
import ContactModalBody from "./contact_modal_body";
import HeaderModalBody from "./header_modal_body";
import OverviewModalBody from "./overview_modal_body";

// Media Outlet's edit modal: consumes the shared <EditModal> shell (chrome only) and keeps the
// engine-specific section -> body mapping + title here (mirrors media_profiles/edit/edit_modal.jsx).
// The bodies own their own <Modal.Body>/<Modal.Footer> (the shell renders children raw). Every body
// is reachable only through an affordance gated on viewerContext.editable, which is the outlet
// policy's admin-only #update? — outlets are Qwoted-curated, so there is no owner-editable path.
function MediaOutletEditModal() {
  const { mediaOutlet, openEditModal, setOpenEditModal, setGeneralError } = useContext(MediaOutletContext);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const sectionLabel = () => {
    switch (openEditModal) {
      case "CONTACT":
        return " - Contact Info";
      case "HEADER":
        return " - Header Info";
      case "OVERVIEW":
        return " - Overview";
      default:
        return null;
    }
  };

  const body = () => {
    // Every body reads the loaded outlet + its plumbing (mediaOutletId, silentReload, setGeneralError,
    // ...) from MediaOutletContext; they take only `close` as a prop.
    switch (openEditModal) {
      case "CONTACT":
        return <ContactModalBody close={closeModal} />;
      case "HEADER":
        return <HeaderModalBody close={closeModal} />;
      case "OVERVIEW":
        return <OverviewModalBody close={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <EditModal
      show={!!openEditModal}
      onClose={closeModal}
      fullscreen="lg-down"
      title={
        <>
          Editing {mediaOutlet?.display_name}
          {sectionLabel()}
        </>
      }
    >
      {body()}
    </EditModal>
  );
}

export default MediaOutletEditModal;
